module.exports = __webpack_public_path__ + "static/media/crm_temp_unique_orders.5131db21.svg";